import ContentShowItem from "MiniSiteComponents/Carousel/Carousel.interface";
import LimitedContent from "GeneralComponents/LimitedContent";

import Consts from "Interfaces/Consts";
import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import { PropsWithChildren } from "react";
import { decodeHtmlEntities } from "../../../../Interfaces/utils/Utils";


type TabPanelProps = {
    contentShowItem: ContentShowItem;
    linkIconType: string;
    itemId: string;
    tabItemId: string;
    componentId: string;
    onClosePanel: () => void;
    isTabpanelContentExpended: boolean;
    isItemContentClamped: boolean;
    onBtnCloseKeyDown: (e: any) => void;
    toggleShowMore: () => void;
    linkTarget?: string;
}

const TabPanel: React.FC<TabPanelProps> = ({ contentShowItem, itemId, linkIconType, componentId, tabItemId, onClosePanel, isItemContentClamped, isTabpanelContentExpended, onBtnCloseKeyDown, toggleShowMore, linkTarget }) => {

    const contentBodyId = tabItemId + '-tabItem-content-' + itemId;
    const wrapperOfReadMore = componentId + '-wrapper-readMore';
    const dir = getComputedStyle(document.documentElement).direction;


    return (
        <div className="mst-tabItemContent" >

            <div className="mst-tabItem-body" >

                <HeaderContainer>

                    <CloseBtn onClosePanel={onClosePanel} />

                    <Title title={contentShowItem.title} />

                    <LimitedContent classNames="mst-tabItem-contentShortDesc" htmlContent={decodeHtmlEntities(contentShowItem.richDescription)} clearHTML={true}></LimitedContent>

                    <hr />
                </HeaderContainer>

                <Content
                    content={contentShowItem.content}
                    isTabpanelContentExpended={isTabpanelContentExpended}
                    wrapperId={contentBodyId}
                />

            </div>

            <ShowMoreBtn
                contentBodyId={contentBodyId}
                isTabpanelContentExpended={isTabpanelContentExpended}
                isVisible={isItemContentClamped}
                linkIconType={linkIconType}
                onBtnCloseKeyDown={onBtnCloseKeyDown}
                toggleShowMore={toggleShowMore}
                wrapperId={wrapperOfReadMore}
            />

            <CustomLinkButton
                title={Consts.readMore}
                pageUrl={contentShowItem.url}
                link={contentShowItem.link}
                isBtn={false}
                btnClass={"btn mst-btn btn-primary px-auto"}
                linkClass={"mst-extra-link txt-pallete-color"}
                dir={dir}
                linkIcon={true}
                charLimit={-3}
                linkTarget={linkTarget}
            />

        </div>

    );
}

export default TabPanel;

type ShowMoreBtnProps = {
    isVisible: boolean;
    wrapperId: string;
    contentBodyId: string;
    isTabpanelContentExpended: boolean;
    linkIconType: string;
    toggleShowMore: () => void;
    onBtnCloseKeyDown: (e: any) => void;
}

const ShowMoreBtn = ({ isVisible, contentBodyId, isTabpanelContentExpended, linkIconType, onBtnCloseKeyDown, toggleShowMore, wrapperId }: ShowMoreBtnProps) => {
    return <div className={`${isVisible ? 'd-block mt-3' : 'd-none'}`} id={wrapperId}>
        <a role="button" className="mt-3 txt-pallete-color"
            aria-controls={contentBodyId}
            aria-expanded={isTabpanelContentExpended}
            onKeyDown={onBtnCloseKeyDown}
            href={"#" + contentBodyId}
            tabIndex={0}
            onClick={toggleShowMore}>
            {
                isTabpanelContentExpended ?
                    <>
                        {Consts.close} <i className="fa fa-fw fa-chevron-up" aria-hidden="true"></i>
                    </> :
                    <>
                        {Consts.showMore} <i className={`fa fa-fw ${linkIconType} `} aria-hidden="true"></i>
                    </>
            }

        </a>
    </div>
}

const HeaderContainer = ({ children }: PropsWithChildren) => {
    return <div className="mst-tabItem-contentHeader">{children}</div>
}

const Content = ({ isTabpanelContentExpended, wrapperId, content }: { wrapperId: string; isTabpanelContentExpended: boolean; content: string; }) => {
    return <div className={`mst-tabItem-contentBody collapse ${isTabpanelContentExpended ? 'show' : ''}`} id={wrapperId} aria-expanded={isTabpanelContentExpended}>
        {
            isTabpanelContentExpended ?
                <div dangerouslySetInnerHTML={{ __html: content }} />
                :
                <LimitedContent htmlContent={content} />
        }
    </div>
}

const CloseBtn = ({ onClosePanel }: { onClosePanel: () => void; }) => {
    return (
        <button className="mst-tabItem-contentClose" type="button" onClick={onClosePanel} >
            <span className="mx-auto">  <i className="icon-minisite-close minisite-font-36" /></span>
        </button>
    )
}

const Title = ({ title}: { title: string }) => {
    return (
        <div className={"mst-tabItem-contentTitle me-5 pe-2"}>
            {title}
        </div>
    )
}






